import React from "react";

const values = [
  {
    title: "Lead-first strategy",
    text: "Every campaign is built around lead quality, conversion, and ROI.",
  },
  {
    title: "Channel coverage",
    text: "We unify social management, SEO, GEO, Google Ads, and Meta Ads.",
  },
  {
    title: "Founder positioning",
    text: "Personal branding systems that create trust and inbound demand.",
  },
  {
    title: "Full-funnel execution",
    text: "From awareness to conversion, we optimize every touchpoint.",
  },
];

export default function ValuePropsSection() {
  return (
    <section className="value-props">
      <div className="section-inner">
        <div className="value-header">
          <p className="section-tag">Why Sparkdenz</p>
          <h2>We blend brand, media, and performance.</h2>
        </div>
        <div className="value-grid">
          {values.map((value) => (
            <div className="value-card" key={value.title}>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
